/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BranchResponseTabletDto } from './branchResponseTabletDto';
import { RoleResponseTabletDto } from './roleResponseTabletDto';

export interface UserRoleResponseTabletDto {
  id: string;
  role: RoleResponseTabletDto;
  branch: BranchResponseTabletDto;
  userGroup: UserRoleResponseTabletDto.UserGroupEnum;
}
// tslint:disable-next-line:no-namespace
export namespace UserRoleResponseTabletDto {
  export type UserGroupEnum = 'executive_wpn' | 'central_staff_wpn' | 'branch_staff_wpn' | 'branch_executive_franchise' | 'branch_staff_franchise';
  export const UserGroupEnum = {
      ExecutiveWpn: 'executive_wpn' as UserGroupEnum,
      CentralStaffWpn: 'central_staff_wpn' as UserGroupEnum,
      BranchStaffWpn: 'branch_staff_wpn' as UserGroupEnum,
      BranchExecutiveFranchise: 'branch_executive_franchise' as UserGroupEnum,
      BranchStaffFranchise: 'branch_staff_franchise' as UserGroupEnum,
  };
}
